/* eslint-disable react/prop-types */
import * as React from 'react';
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
//Components, Styles, State
import './DataTable.module.scss';
import styles from './DataTable.module.scss';

type PickedHeaders = {
    value: string;
    topic: string;
    label: string;
};

type PickedStates = {
    value: string;
    label: string;
};

type PickedTopics = {
    value: string;
    label: string;
};

interface StickyHeadTableProps {
    data: any[];
    pickedTopics: PickedTopics[];
    pickedStates: PickedStates[];
    pickedHeaders: PickedHeaders[];
    style: {zIndex: string};
}

// Checks the list of headers selected in the header drop-down (all selected by default)
const hasHeader = (headers: any[], header: any): boolean => {
    let isThere = false;
    for (const item of headers) {
        if (item.value === header.value && item.topic === header.topic) {
            isThere = true;
            break;
        }
    };
    return isThere;
};

//Creates the table header row with the key used for mapping cells to a column
const makeHeaderRow = (topic: string, headers: any, columnSpan: number): JSX.Element => {
    if (topic === headers.topic) {
        return (
            <TableCell 
                className={styles.CellHeader}
                align="center" 
                colSpan={columnSpan}
                >
                    {headers.value}
            </TableCell>
        )
    };
};

//Creates the table, row by row. Each creation of cell calls createRowCells()
const createRows = ({ props, data, maxColumns }: any) => {
    if (typeof props.pickedStates !== "undefined") {
        return (props.pickedStates.map(state => {
                return ( createRowCells({ state, data, maxColumns, props }))
            })
        )
    } else { setTimeout("250") }
};

//creates row cells with their column key mappings
const createRowCells = ({ state, data, maxColumns }: any): JSX.Element => {
    return (
        <TableRow key={state.value}>
            <TableCell align="center" 
                className={styles.FirstColumn}
                colSpan={maxColumns%(data.length+1) + maxColumns/(data.length+1)}>
                    {state.label}
            </TableCell>
            {data.map( item => {
                let stateTopic = state.value;
                return (
                    <TableCell 
                        className={styles.Cell}
                        colSpan={maxColumns/(data.length+1)}>
                            {item[stateTopic]}
                    </TableCell>
                )
            })}
        </TableRow>
    );
};

//Finds the table with the most columns
const findNumberOfColumns = (props: any): number => {
    const temp = []
    props.data.forEach(value  => { temp.push(value.length+1) })
    return Math.max.apply(Math, temp);
};

//Maps the data pulled from the OPUS API into the table components using the above functions
const StickyHeadTable = (props: StickyHeadTableProps): JSX.Element => {
    const maxColumns = findNumberOfColumns(props);
    let reOrderedHeaders = [];
    return (
        <Paper className={styles.Root}>
            <TableContainer>
                    {props.data.map( data => {
                        // Filter the data to only include selected headers
                        data = data.filter(data => {
                            let tempString = data.header.replace('\'', '\'\'');
                            let tempTopicHeader = {
                                value: tempString,
                                topic: data.topic
                            };

                            // Re-order the headers so the columns always line up with the correct headers
                            if(hasHeader(props.pickedHeaders, tempTopicHeader)) {
                                reOrderedHeaders.push(tempTopicHeader);
                                return true;
                            } else {
                                return false;
                            }
                        })
                        return (
                            typeof data[0] !== "undefined" ?
                                (
                            <Table stickyHeader aria-label="sticky table" 
                                className={styles.StickyTable}
                            >
                                <TableHead>
                                    <TableRow key={"headers"}
                                    >
                                        <TableCell component="th" scope="row" id={data[0].topic} align="center" 
                                            className={styles.CellHeader}
                                            colSpan={maxColumns%(data.length+1) + maxColumns/(data.length+1)}>
                                                {data[0].topic}
                                        </TableCell>
                                        {reOrderedHeaders.map(header => {
                                                let columnSpan = maxColumns/(data.length+1);
                                                return (makeHeaderRow(data[0].topic, header, columnSpan));
                                            }
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {createRows({ props, data, maxColumns })}
                                </TableBody>
                            </Table>
                        ) : null)
                    })
                    }
            </TableContainer>
        </Paper>
    );
};

export default StickyHeadTable;